// ProtectedRoute.js
import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = !!sessionStorage.getItem("jwtToken");
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      toast.dismiss(); // Clear all toasts
      setShowSessionModal(true);
      const timer = setTimeout(() => {
        setShouldRedirect(true);
      }, 3000); // 3 seconds
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated]);

  const handleSignIn = () => {
    setShouldRedirect(true);
  };

  if (!isAuthenticated) {
    if (shouldRedirect) {
      return <Navigate to="/signin" state={{ from: location }} replace />;
    }
    return (
      <Dialog open={showSessionModal} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ textAlign: "center", fontWeight: 700 }}>Session Expired</DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center", mb: 2 }}>
            Your session has expired. Please sign in again to continue.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSignIn}
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            Sign In
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return children;
};

export default ProtectedRoute;